import React from 'react';
import { Link } from 'react-router-dom';
import '../css/Impressum.css'; // We'll create this CSS file next

function Impressum() {
  return (
    <div className="impressum-container">
      <div className="impressum-content">
        <h1 className="impressum-title">Impressum</h1>
        
        <section className="impressum-section">
          <h2>Angaben gemäß § 5 TMG</h2>
          <p>
            Musterfirma GmbH<br />
            Musterstraße 123<br />
            12345 Musterstadt
          </p>
        </section>

        <section className="impressum-section">
          <h2>Vertreten durch</h2>
          <p>
            Geschäftsführer: Max Mustermann<br />
            Handelsregister: HRB 12345<br />
            Registergericht: Amtsgericht Musterstadt
          </p>
        </section>

        <section className="impressum-section">
          <h2>Kontakt</h2>
          <p>
            Telefon: +49 (0) 123 456789<br />
            E-Mail: info@musterfirma.de<br />
            Website: www.musterfirma.de
          </p>
        </section>

        <section className="impressum-section">
          <h2>Umsatzsteuer-ID</h2>
          <p>
            Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz:<br />
            DE123456789
          </p>
        </section>

        <section className="impressum-section">
          <h2>Verantwortlich für den Inhalt</h2>
          <p>
            Max Mustermann<br />
            Musterstraße 123<br />
            12345 Musterstadt
          </p>
        </section>

        <section className="impressum-section">
          <h2>Haftungsausschluss</h2>
          <h3>Haftung für Inhalte</h3>
          <p>
            Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
          </p>
          <h3>Haftung für Links</h3>
          <p>
            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
          </p>
        </section>

        <div className="impressum-footer">
          <Link to="/" className="home-link">← Zurück zur Startseite</Link>
        </div>
      </div>
    </div>
  );
}

export default Impressum;